import { createSlice } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'

const initialState = {
  loading: {
    fetchRoleOptions: false,
    fetchRole: false,
    fetchRoleList: false,
    adding: false,
    updating: false,
    changingStatus: false,
    deleting: false,
  },
  roleOptions: [],
  role: null,
  roleList: [],
}

export const organizationRolesSlice = createSlice({
  name: 'organizationRoles',
  initialState,
  reducers: {
    setLoading: (state, { payload }) => {
      const alteredState = {
        ...state,
        loading: { ...state.loading, ...payload },
      }
      return alteredState
    },
    setRoleOptions: (state, { payload }) => {
      const alteredState = {
        ...state,
        roleOptions: payload,
      }
      return alteredState
    },
    setRole: (state, { payload }) => {
      const alteredState = { ...state, role: payload }
      return alteredState
    },
    setRoleList: (state, { payload }) => {
      const alteredState = {
        ...state,
        roleList: payload,
      }
      return alteredState
    },
    reset: () => initialState,
  },
})

export const useOrganizationRoleSelector = () =>
  useSelector((state) => state.organizationRoles)
export const organizationRolesActions = organizationRolesSlice.actions
export const organizationRolesReducer = organizationRolesSlice.reducer
